import { serverSideConfigs, t } from 'localization'
import { useTranslation } from 'next-i18next'
import { Trans } from 'react-i18next'
import { FCLink } from 'shared/components/Links'
import StaticPage from 'shared/components/StaticPage'
import { PagesQA } from 'shared/dataAttributes'
import { FCGetServerSidePropsContext, getServerPageProps } from 'shared/utils/getServerSideProps'

const TP = 'pages.press'
const Press = () => {
  const tv = useTranslation()
  return (
    <StaticPage
      qaAttr={PagesQA.PressAndMedia}
      title={t(`${TP}.pressMedia`, 'Press & Media Requests')}
      heroImagePath="/static/staticPages/press-and-media.png"
    >
      <StaticPage.Paragraph>
        <Trans
          i18nKey={`${TP}.pleaseDirectAll`}
          t={tv.t}
          defaults="For all media inquiries, including requests for interviews, filming releases and high-resolution images, please contact <0>media@flightclub.com</0>. Our Media Relations team will review your request and respond accordingly."
          components={[
            <FCLink qaAttr={PagesQA.MediaEmailLink} href="mailto:media@flightclub.com" />,
          ]}
        />
      </StaticPage.Paragraph>
      <StaticPage.Paragraph>
        <Trans i18nKey={`${TP}.pleaseNote`} t={tv.t}>
          If you would like to film inside one of our locations, you must receive prior approval.
          Filming is typically not permitted at our stores, and all requests must be thoroughly
          vetted and approved.
        </Trans>
      </StaticPage.Paragraph>
      <StaticPage.Paragraph>
        {t(`${TP}.weAreUnable`, 'Please note that we cannot fulfill all requests.')}
      </StaticPage.Paragraph>
    </StaticPage>
  )
}

export const getServerSideProps = async (context: FCGetServerSidePropsContext) => {
  const { res, locale } = context
  return {
    props: {
      ...(await getServerPageProps(context)),
      ...(await serverSideConfigs(res, locale)),
    },
  }
}

export default Press
